"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propType = exports.isValidColorHex = void 0;

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var isValidColorHex = function isValidColorHex(color) {
  return /^#?[0-9A-Fa-f]{0,6}$/.test(color);
};

exports.isValidColorHex = isValidColorHex;

var color = function color(props, propName, componentName) {
  if (props[propName]) {
    var value = props[propName];

    if (!isValidColorHex(value)) {
      return new Error(componentName + ": Invalid color value. Expected format RRGGBB, got \"" + value + "\".");
    }
  }

  return null;
};

var propType = (0, _createChainablePropType.default)(color, 'color');
exports.propType = propType;